import gsap from 'gsap';
export class FirstTweenCheck {
    tweenFunction;
    timeout = 0;
    tween;
    checked = false;
    constructor() {
        this.tweenFunction = () => {
            this.timeout = window.setTimeout(this.checkAgain.bind(this), 150);
            this.tween = gsap.to('body', {
                onComplete: this.afterChecked,
                callbackScope: this,
                duration: 0.01
            });
        };
    }
    start() {
        if (document.readyState === 'complete' || document.readyState === 'interactive') {
            const callback = this.tweenFunction.bind(this);
            setTimeout(callback, 1);
        }
        else {
            document.addEventListener('DOMContentLoaded', this.tweenFunction.bind(this));
        }
    }
    checkAgain() {
        if (!this.checked && this.tween && this.tween.progress() === 0) {
            console.warn('!!!!!!!!!!!!!!!!!! GSAP dalsi pokus!!!!');
            this.tweenFunction();
        }
    }
    afterChecked() {
        if (this.checked)
            return;
        this.checked = true;
        window.clearTimeout(this.timeout);
        console.log('First tween check');
    }
}
//# sourceMappingURL=FirstTweenCheck.js.map